module.exports = __webpack_public_path__ + "img/round.8c835643.png";